import Axios from "axios";
var StockInitService = (function () {
    function StockInitService() {
    }
    StockInitService.prototype.getList = function (params) {
        return Axios.get("supplierclientapi/stockinit/list", { params: params });
    };
    StockInitService.prototype.audit = function (params) {
        return Axios.get("supplierclientapi/stockinit/do_audit", { params: params });
    };
    StockInitService.prototype.discard = function (params) {
        return Axios.get("supplierclientapi/stockinit/do_cancel", { params: params });
    };
    StockInitService.prototype.getOrgandepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_organdepot_options", { params: params });
    };
    StockInitService.prototype.getSupplierorganOptions = function (params) {
        return Axios.get("supplierclientapi/supplierorgan/get_options", { params: params });
    };
    StockInitService.prototype.getSupplierdepotOptions = function (params) {
        return Axios.get("supplierclientapi/supplierdepot/get_options", { params: params });
    };
    StockInitService.prototype.getStockinitGoodslist = function (params) {
        return Axios.post("supplierclientapi/suppliergoods/stockinit_goodslist", params);
    };
    StockInitService.prototype.addSave = function (data) {
        return Axios.post("supplierclientapi/stockinit/save_order", data);
    };
    StockInitService.prototype.getDetail = function (params) {
        return Axios.get("supplierclientapi/stockinit/detail", { params: params });
    };
    StockInitService.createInstance = function () {
        StockInitService.getInstance();
    };
    StockInitService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return StockInitService;
}());
export default StockInitService;
